import { Alert } from '@material-ui/lab'
import { Grid, Typography, IconButton, Tooltip } from "@material-ui/core"
import { useSelector, useDispatch } from "react-redux"
import { grupoDetalleStyles } from "./styles"
import HomePage from "../../Home"
import { useHistory } from "react-router-dom"
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount'
import TGrupoDetalle from "./TGrupoDetalle"
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { obtenerFecha, obtenerGrupoAction } from '../../../ducks/viajeCalendarioDuck'
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn';
import BackDrop from '../../../global/BackDrop'
import ButtonPagoGrupal from './ButtonPagoGrupal'
const VGrupoDetalle = () => {
  const Params = useParams()
  const [load, setLoad] = useState(false)
  const { fecha, grupo, fechaCorta, grupoDetail } = useSelector((store) => store.calendario);
  const dispatch = useDispatch()
  const classes = grupoDetalleStyles();
  const history = useHistory()

  useEffect(() => {
    dispatch(obtenerFecha())
  }, [dispatch])

  useEffect(() => {
    setLoad(true)
    dispatch(obtenerGrupoAction({ fecha: Params?.fecha, nombre: Params?.paquete })).then(Response => {
      setLoad(false)
    })
  }, [dispatch, Params?.fecha, Params?.paquete])

  const onCalendario = () => {
    history.push(`/Calendario/${fechaCorta}`, {
      fechaCorta: fecha
    })
  }

  return (
    <HomePage>
      <Grid container>
        <Grid item xs={12} className={classes.containerHead}>
          <div>
            <div className={classes.titlePaquete}>
              <ul style={{ listStyle: "none", padding: "10px 20px 0 0", margin: "0" }}>
                <li>Paquete: {grupoDetail?.NombrePaquete}</li>
              </ul>
            </div>
            <div className={classes.title}>
              <div>
                <ul style={{ listStyle: "none", padding: "10px 20px 0 0" }}>
                  <li>Salida: {fecha}</li>
                  <li>Num. Plazas: {grupoDetail?.NumPlazas} </li>
                </ul>
              </div>
              <div>
                <ul style={{ listStyle: "none", padding: "10px 20px 0 0" }}>
                  <li>Total Reserva: {grupoDetail?.TotalReservas} </li>
                  <li>Total Documentos: {grupoDetail?.TotalDocuemntos}</li>
                </ul>
              </div>
              <div>
                <ul style={{ listStyle: "none", padding: "10px 20px 0 0" }}>
                  <li>Total Aereos: {grupoDetail?.TotalAereos} </li>
                  <li>Total Liquidación: {grupoDetail?.TotalLiquidacion}</li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <Tooltip title="Calendario">
              <IconButton aria-label="Calendario" onClick={onCalendario}>
                <KeyboardReturnIcon />
              </IconButton>
            </Tooltip>
          </div>
        </Grid>
        <Grid item xs={12} className={classes.containerHead}>
          <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <Typography component="h5" variant="h5">
                <SupervisorAccountIcon fontSize='large' /> Grupo
              </Typography>
            </div>
            <div>
              <ButtonPagoGrupal />
            </div>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.root}>
            {
              (grupo.length <= 0) &&
              <div>
                <Alert severity="info">No hay datos por mostrar</Alert>
              </div>
            }
            {
              (grupo.length > 0) &&
              <TGrupoDetalle rows={grupo} />
            }
          </div>
        </Grid>
      </Grid>
      <BackDrop open={load} />
    </HomePage>

  );
};
export default VGrupoDetalle;
